import type { FieldChangeEvent } from "~business/Cards/types";
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import ItemSearchableInputCard, {
  ListItem,
} from "~business/Cards/ItemSearchableInputCard";

import { getPolizas, getPoliza } from "../actions";
import { aCampoSiniestro, CampoSiniestro, OpcionSiniestro } from "../../types";

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: "50%",
    "@media (max-width:1024px)": {
      width: "90%",
    },
  },
  body: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "5px",
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    backgroundColor: theme.colours.white,
    margin: "2%",
    width: "100%",
  },
}));

interface SliceBusqueda {
  polizas: OpcionSiniestro[];
}

const useReduxSelector = () =>
  useSelector<any, SliceBusqueda>((state) => ({
    polizas: state.cargaSiniestroPublicaReducer.polizasFilter,
  }));

interface BusquedaCardProps {
  isLoading?: boolean;
}

const BusquedaCard = ({ isLoading }: BusquedaCardProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [busqueda, setBusqueda] = useState<CampoSiniestro>({
    value: "",
    valid: false,
    focus: false,
  });

  const { polizas } = useReduxSelector();

  let timer: ReturnType<typeof setTimeout> | undefined;

  const handleChangeBusqueda = (busqueda: FieldChangeEvent<string | null>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setBusqueda(aCampoSiniestro(busqueda));
    }, 200);
  };

  const handleClickBusqueda = () => {
    if (!busqueda.value.trim()) return; //nothing to search
    dispatch(
      getPolizas({
        skip: 0,
        take: 10,
        searchCriteria: busqueda.value,
        estado: "Vigente",
      })
    );
  };

  const handleChangePoliza = (poliza: ListItem) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (poliza.value) dispatch(getPoliza(poliza.value));
    }, 200);
  };

  return (
    <>
      <div className={classes.root}>
        <div className={classes.body}>
          <div className={classes.card}>
            <ItemSearchableInputCard
              id={"busquedaPoliza"}
              isLoading={isLoading}
              label={"Búsqueda de Póliza"}
              value={busqueda.value}
              onChange={handleChangeBusqueda}
              onChangeItem={handleChangePoliza}
              onClick={handleClickBusqueda}
              tooltipContent={"Buscar Póliza"}
              placeholder={"Ingresá tu DNI o patente"}
              items={polizas}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BusquedaCard;
